'use client';
import { ReactNode, type ComponentProps } from 'react';
import { IntlProvider, ReactIntlErrorCode } from 'react-intl';
interface IntlProviderProps {
  children: ReactNode;
  locale: string;
  messages: Record<string, string>;
}

const shouldSilenceMissingTranslationErrors = () =>
  process.env.NEXT_PUBLIC_SILENCE_MISSING_TRANSLATION_ERRORS === 'true';

const handleIntlError: NonNullable<ComponentProps<typeof IntlProvider>['onError']> = (error) => {
  if (shouldSilenceMissingTranslationErrors() && error.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
    return;
  }

  console.error(error);
};

export function IntlProviderWrapper({ children, locale, messages }: IntlProviderProps) {
  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale="en" onError={handleIntlError}>
      {children}
    </IntlProvider>
  );
}
